import {Action, handleActions} from 'redux-actions';
import {Descriptor} from 'QCTools/QCToolsMetadata/QCToolsMetadataTypes';
import {SET_QC_DESCRIPTORS} from './ratingDescriptorsAction';

export interface State {
    isLoading: boolean,
    descriptors: Descriptor[],
}

export const initialState = {
    isLoading: true,
    descriptors: [],
};

export const setQcDescriptors = (state: State, action: Action<Descriptor[]>) => {
    const {payload} = action;
    return {
        descriptors: payload,
        isLoading: false,
    };
};

const handlers = {
    [SET_QC_DESCRIPTORS]: setQcDescriptors,
};

export default handleActions(handlers, initialState);
